"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.VideoPlayCircle = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var classnames_1 = __importDefault(require("classnames"));
var icons_1 = require("../../icons");
// absolute positioned by default, or use inline prop
var VideoPlayCircle = function (_a) {
    var _b = _a.size, size = _b === void 0 ? 'lg' : _b, inverted = _a.inverted, inline = _a.inline, className = _a.className;
    var TriangleIcon = size == 'xxl'
        ? icons_1.TriangleRightSolid64
        : size == 'lg' || size == 'xl'
            ? icons_1.TriangleRightSolid48
            : icons_1.TriangleRightSolid32;
    return ((0, jsx_runtime_1.jsx)("div", __assign({ className: (0, classnames_1.default)("square-".concat(size, " rounded-circle shadow-xl"), inverted ? 'bg-dark' : 'bg-white', inline ? 'position-relative' : 'absolute-center', className) }, { children: (0, jsx_runtime_1.jsx)("div", __assign({ className: "absolute-center" }, { children: (0, jsx_runtime_1.jsx)(TriangleIcon, {}) })) })));
};
exports.VideoPlayCircle = VideoPlayCircle;
